import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { DatePipe, Location } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PendingVendorDto } from '../../../../models/pending-vendor-dto';
import { WithHoldingTaxDto } from '../../../../models/with-holding-tax-dto';

interface PaymentTerm {
  payment_term_description: string;
  payment_term_code: string;
}
interface WithHoldingTaxCode {
  tax_code: string;
  description: string;
}
interface WithHoldingTaxType {
  tax_type: string;
  description: string;
}
interface ReconciliationType {
  type: string;
  description: string;
}
@Component({
  selector: 'app-vendor-detail',
  templateUrl: './vendor-detail.component.html',
  styleUrl: './vendor-detail.component.scss'
})
export class VendorDetailComponent implements OnInit {
  @Input() closable: boolean = true;
  vendor: any;
  documents: { name: string, file: string, document_name: string }[] = []; // Add documents array
  legalDocuments: { name: string, file: string }[] = [];
  thridPartyScoreDocuments: { name: string, file: string }[] = [];
  vendorList: any[] = [];
  vm_contact_detail: any[] = [];
  contact_persion: any[] = [];

  selectedVendorList: string[] = [];
  paymentterm1: any[] = [];

  isVendorStatus: boolean = false
  isAuditorApprovalForChange: boolean = false
  isLoading: boolean = false;

  accountgroup: string = '';
  withholdingtax: string = '';
  purchaseOrgannization: string = '';
  paymentTerm: string = '';
  riskScore: string = '';
  evaluatedScore: string = '';
  paymentterm: any[] = []
  isPendingApproval1 = false
  isPendingApproval2 = false
  isSelectNo = false
  pendingreview = false
  pendingApprovalForDialog = false
  pendingRejectForDialog = false
  isDialogSummary = false
  scoreList: string[] = [];
  PendingVendorDto?: PendingVendorDto

  thrid_party_evaluated_scorecard_doc: File | null = null;
  thrid_party_business_score_doc: File | null = null;
  isRejectDialog = false
  isApproveDialog = false
  isWithHoldingTaxYes = false
  rejectReason: string=''
  Wthttype: any =''
  Wtaxcode: any=''
  RectyData: any = ''
  WithHoldingTaxType: string = ''
  WithHoldingTaxCodeName: string = ''
  reconciliationName: string = ''
  ExemptionNumber: string = ''
  Exem: string = ''
  ExemptFrom?: Date | null;
  ExemptTo?: Date | null;
  headerStatus: string = ''
  cin: string = ''
  pan_doc: string = ''
  msme_doc: string = ''
  mca_doc: string = ''
  profile_doc: string = ''
  gst_doc: string = ''
  bank_doc: string = ''
  company_registration_doc: string = ''
  other_doc: string = ''
  self_declaration_by_vendor: string = ''
  highlights_detail:any
  isVendor = false
  withHoldingTaxCode: any[] = []
  withHoldingTaxTypeList: any[] = []
  reconciliationTypeList: any[] = []
  vendorPayableAccountsList: any[] = []

  sidebarVisible:boolean = false
  withHoldingMultiData: WithHoldingTaxDto[] = [];
  isApproved = true
  isApproved2 = false
  businessName2:string=''
  isAuditor=false
  FRAPPE_API_URL = environment.FRAPPE_API_URL;
  constructor(
    private route: ActivatedRoute,
    private vendorService: VendorTsService,
    private location: Location,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    private datePipe: DatePipe,

  ) {
    this.PendingVendorDto = new PendingVendorDto()
  }

  public withholdingtax1 = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" }
  ]

  removeDuplicates(arr: any[], type: string): any[] {
    const uniqueItems = new Set();
    return arr.filter(item => {
      let itemString;
      if (type === 'itemString') {
        itemString = `${item.first_name}-${item.last_name}-${item.rockman_contact_department}-${item.rockman_contact_function}`;
      } else if (type === 'itemString1') {
        itemString = `${item.vm_name}-${item.telephone}-${item.email_id}-${item.mobile_phone}`;
      }

      if (uniqueItems.has(itemString)) {
        return false;
      } else {
        uniqueItems.add(itemString);
        return true;
      }
    });
  }

   async ngOnInit(): Promise<void> {

    for (let i = 0; i <= 100; i++) {
      this.scoreList.push(i.toString());
    }
    await this.vendorService.checkIfVendor()
    .then((response) => {
      this.isVendor = response.message.roles.includes("Vendor")
      this.isAuditor=response.message.roles.includes("Vendor Auditor")
    }).catch((error) => {
      console.log(error)
    });

    const businessName = this.route.snapshot.paramMap.get('id');
    if (businessName) {

      this.vendorService.getVendorById(businessName).then((vendor: any) => {
        this.vm_contact_detail = this.removeDuplicates(vendor.message.vm_contact_list, 'itemString1');
        this.contact_persion = this.removeDuplicates(vendor.message.contact_list, 'itemString');

        this.vendor = vendor.message;
        if (vendor.message.highlights_detail) {
          this.highlights_detail = JSON.parse(vendor.message.highlights_detail);
        }
        this.cin = vendor.message.upload_cin
        this.businessName2 = vendor.message.business_name
        this.pan_doc = vendor.message.pan_document
        this.msme_doc = vendor.message.msme_certificate
        this.mca_doc = vendor.message.mca_document
        this.profile_doc = vendor.message.propertiery_img
        this.gst_doc = vendor.message.primary_address.tax_details.upload_gst
        this.bank_doc = vendor.message.primary_address.bank_detail.cancelled_cheque
        this.company_registration_doc = vendor.message.company_registration
        this.other_doc = vendor.message.other_documents
        this.self_declaration_by_vendor = vendor.message.other_documents
        this.PendingVendorDto!.business_name = vendor.message.business_name
        if (vendor.message.status === "PENDING_ADMIN_APPROVAL") {
          this.isVendorStatus = true
        }
        if (vendor.message.status === "PENDING_APPROVER_1") {
          this.isPendingApproval1 = true
          this.isVendorStatus = true
        }
        if (vendor.message.status === "PENDING_APPROVER_2") {
          this.isPendingApproval2 = true
          this.isVendorStatus = true
        }
        if (vendor.message.status === "PENDING_REVIEW") {
          this.pendingreview = true
          this.isVendorStatus = true
        }
        if (this.isAuditor && this.vendor.status === "PENDING_APPROVER") {
          this.isVendorStatus = true
          this.isAuditorApprovalForChange=true
        }
        this.selectedVendorList.push(vendor.message.business_name)
        this.documents = [
          { name: 'Evaluation Sheet', file: vendor.message.evaluation_sheet, document_name: '' },
          { name: 'Company Profile', file: vendor.message.document_1, document_name: vendor.message.document_1_name },
          { name: 'Balance Sheet', file: vendor.message.document_2, document_name: vendor.message.document_2_name },
          { name: 'Auditor Report', file: vendor.message.document_3, document_name: vendor.message.document_3_name },
          { name: 'ISO Certificate', file: vendor.message.document_4, document_name: vendor.message.document_4_name },
          { name: 'List Of Equipment', file: vendor.message.document_5, document_name: vendor.message.document_5_name },
          { name: 'Other', file: vendor.message.document_6, document_name: vendor.message.document_6_name },
        ];
        this.thridPartyScoreDocuments = [
          { name: '3rd Party Business Score Doc', file: vendor.message.thrid_party_business_score_doc },
          { name: '3rd Party Evaluated Scorecard Doc', file: vendor.message.thrid_party_evaluated_scorecard_doc },
        ]
        this.legalDocuments = [
          // { name: 'Self Declaration By Vendor', file: vendor.message.self_declaration_by_vendor },
          // { name: 'MSME Certificate', file: vendor.message.msme_certificate },
          // { name: 'Company Registration', file: vendor.message.company_registration },
          // { name: 'Other Documents', file: vendor.message.other_documents },
          // { name: 'CIN', file: vendor.message.upload_cin },
          // { name: 'GST', file: vendor.message.primary_address.tax_details.upload_gst },
          // { name: 'Bank Document', file: vendor.message.primary_address.bank_detail.cancelled_cheque },
        ]

      }).catch((error: any) => {
        console.error('Error fetching vendor details:', error);
      });
    }




    this.vendorService.getPaymentTerms().then((response) => {
      this.paymentterm = response.message

      this.paymentterm.forEach((pt) => {
        let pt1: PaymentTerm = {
          payment_term_code: pt.payment_term_code,
          payment_term_description: `${pt.payment_term_code}-${pt.payment_term_description}`
        };

        this.paymentterm1.push(pt1);
      });
    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.getWithHoldingTaxCode().then((response) => {
      response.message.forEach((pt:any) => {
        let pt1: WithHoldingTaxCode = {
          tax_code: pt.tax_code,
          description: `${pt.tax_code}-${pt.description}`
        };

        this.withHoldingTaxCode.push(pt1);
      });

    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.getWithHoldingTaxType().then((response) => {

      response.message.forEach((pt:any) => {
        let pt1: WithHoldingTaxType = {
          tax_type: pt.tax_type,
          description: `${pt.tax_type}-${pt.description}`
        };

        this.withHoldingTaxTypeList.push(pt1);
      });

    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.ReconciliationType().then((response) => {
      response.message.forEach((pt:any) => {
        let pt1: ReconciliationType = {
          type: pt.type,
          description: `${pt.type}-${pt.description}`
        };

        this.reconciliationTypeList.push(pt1);
      });

    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.VendorPayableAccounts().then((response) => {
      this.vendorPayableAccountsList = response.message

    }).catch((error) => {
      console.log(error)
    })

  }
  goBack(): void {
    this.location.back();
  }
  downloadFile(filePath: string): void {
    const url = this.FRAPPE_API_URL + filePath;

    const fileExtension = filePath.split('.').pop();
    let fileName = 'download';
    if (fileExtension) {
      fileName += '.' + fileExtension;
    }

    this.vendorService.downloadFile(url).subscribe(blob => {
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    });
  }






  //   approvedVendor() {
  //     this.confirmationService.confirm({
  //       message: 'Are you sure you want approve ?',
  //       header: 'Confirm',
  //       icon: 'pi pi-exclamation-triangle',
  //       accept: () => {
  //         this.vendorService.approve_vendors(this.selectedVendorList).then((res)=>{
  //           if(res.message.status == "Failed"){
  //             this.messageService.add({ severity: 'error', summary: 'Failed', detail:res.message.message, life: 5000 });
  //           }else{
  //             this.messageService.add({ severity: 'success', summary: 'Successful', detail:res.message.message, life: 1000 });
  //           }
  //           // this.messageService.add({ severity: 'success', summary: 'Successful', detail:res.message.message, life: 1000 });
  //           this.isVendorStatus=false
  //         }).catch((error)=>{
  //           console.log(error)
  //           this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
  //         })
  //       }
  //   });
  // }

  getShortKey(longKey: string): string | null  {

    const keyMap: { [key: string]: string } = {
      // "new_rockman_contact_detail.1":"new_rockman_contact_detail 1",
      // "new_vm_contact_detail.3":"new_vm_contact_detail 3",
      "mca_number":'MCA Number',
      "select_industry_type":"Select Industry Type",
      "vendor_type":"Vendor Type",
      "vendor_classification":"Vendor Classification",
      "previous_year":"Previous Year",
      "one_year_before_previous_year":"One Year Before Previous Year",
      "two_years_before_previous_year":"Two Years Before Previous Year",
      "legal_name":"Legal Name",
      "cin_no":"Cin No",
      "tin_no":"Tin No",
      "din_no":"Din No",
      "msme_no":"MSME No",
      "aadhar_no":"Aadhar No",
      "propertiery_img":"Profile Photo",
      "msme_certificate":"MSME Certificate",
      "company_registration":"Company Registration",
      "other_documents":"Other Documents",
      "upload_cin":"CIN Document",
      "mca_document":"MCA Document",
      "evaluation_sheet":"Evaluation Sheet",
      "document_1_name":"Company Profile",
      "document_1":"Company Profile Document",
      "document_2_name":"Balance Sheet",
      "document_2":"Balance Sheet",
      "document_3_name":"Auditor Report",
      "document_3":"Auditor Report",
      "document_4_name":"ISO Certificate ",
      "document_4":"ISO Certificate",
      "document_5_name":"List Of Equipment",
      "document_5":"List Of Equipment Document",
      "document_6_name":"Other",
      "document_6":"Other Document",
      "msme_expiry_year":"MSME Expiry Year",
      "primary_address.address_title":"Address Title",
      "primary_address.address_line_1":"Street / House Number",
      "primary_address.address_line_2":"District",
      "primary_address.city":"City",
      "primary_address.state1":"State/Province",
      "primary_address.postal_code":"Postal Code",
      "primary_address.fax":"Fax",
      "primary_address.address_type":"Address Type",
      'primary_address.bank_detail.account_holder__registered_name': 'Account Holder Name',
      'primary_address.bank_detail.account_no': 'Account No',
      'primary_address.bank_detail.bank_name': 'Bank Name',
      'primary_address.bank_detail.bank_address': 'Bank Address',
      "primary_address.bank_detail.ifsc_code": 'Ifsc Code',
      'primary_address.bank_detail.branch_name': 'Branch Name',
      'primary_address.bank_detail.bank_city': 'Bank City',
      "primary_address.bank_detail.bank_region": 'Bank Region',
      "primary_address.bank_detail.cancelled_cheque": 'Bank Document',
      "primary_address.tax_details.upload_gst": 'GST Document',
      'primary_address.tax_details.vat_registration_number': 'Vat Registration Number',
      'primary_address.tax_details.service_tax_registration_number': 'Service Tax Registration Number',
    };

    return keyMap[longKey] || null;
  }


  getFilteredDetails() {
    if (this.highlights_detail) {
      return this.highlights_detail.filter((detail:any) => this.getShortKey(detail.key));
    }
  }


  openConfirmationDialog() {
    if (this.isAuditor && this.vendor.status === "PENDING_APPROVER") {
      this.pendingApprovalForDialog=true
    }else{
      this.isApproveDialog = true
      this.withholdingtax=''
    }
    }

    openSummaryDialog(){
      this.isDialogSummary=true
    }


  openRejectDialog() {
    if (this.isAuditor && this.vendor.status === "PENDING_APPROVER") {
      this.pendingRejectForDialog=true
    }else{
      this.isRejectDialog = true
    }
  }

  isFormValid(): boolean {
    if (this.isPendingApproval1) {
      return this.accountgroup !== '' && this.paymentTerm !== '';
    } else if (this.isPendingApproval2) {
      if (this.isSelectNo) {
        return true
      } else {
        return this.withholdingtax !== '' && this.reconciliationName !=='' && this.WithHoldingTaxType !=='' && this.WithHoldingTaxCodeName !==''  && this.Wthttype !== '' && this.Wtaxcode !== '' && this.RectyData !== '' && this.ExemptionNumber !== '' && this.Exem !== '' && this.ExemptFrom !== undefined && this.ExemptTo !== undefined;
      }
      // return this.withholdingtax !== '';
    } else if (this.pendingreview) {
      return this.riskScore !== '' && this.evaluatedScore !== ''
    }
    return false;
  }


  onUploadFile($event: any, type: string) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      const fileUrl = `/private/files/${file.name}`;
      if (type === 'thrid_party_business_score_doc') {
        this.thrid_party_business_score_doc = file;
      } else if (type === 'thrid_party_evaluated_scorecard_doc') {
        this.thrid_party_evaluated_scorecard_doc = file;
      }
      // this.registrationForm.patchValue({
      //   [type]: fileUrl,
      // });

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${type} uploaded successfully`,
      });
    } else {
      console.error(`Please select a ${type}.`);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Please select a ${type}.`,
      });
    }
  }

  cancelUpload(type: string) {
    if (type === 'thrid_party_business_score_doc') {
      this.thrid_party_business_score_doc = null;
    } else if (type === 'thrid_party_evaluated_scorecard_doc') {
      this.thrid_party_evaluated_scorecard_doc = null;
    }
  }


  approvedVendor() {
    this.sidebarVisible = false
    this.confirmationService.close();
    this.isLoading = true
    const uploadPromises = [];
    if (this.thrid_party_business_score_doc) {
      const msmeArgs = {
        is_private: '1',
        folder: 'Home',
        file_url: `/private/files/${this.thrid_party_business_score_doc.name}`,
        doctype: 'Vendor Master',
        docname: this.PendingVendorDto!.business_name,
        fieldname: 'thrid_party_business_score_doc',
      };
      const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
      uploadPromises.push(
        this.vendorService
          .uploadFile(path, this.thrid_party_business_score_doc, msmeArgs)
          .toPromise()
      );
    }
    if (this.thrid_party_evaluated_scorecard_doc) {
      const msmeArgs1 = {
        is_private: '1',
        folder: 'Home',
        file_url: `/private/files/${this.thrid_party_evaluated_scorecard_doc.name}`,
        doctype: 'Vendor Master',
        docname: this.PendingVendorDto!.business_name,
        fieldname: 'thrid_party_evaluated_scorecard_doc',
      };
      const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
      uploadPromises.push(
        this.vendorService
          .uploadFile(path, this.thrid_party_evaluated_scorecard_doc, msmeArgs1)
          .toPromise()
      );
    }

    if (this.accountgroup != null && this.accountgroup != undefined) {
      this.PendingVendorDto!.account_group = this.accountgroup
    }
    if (this.paymentTerm != null && this.paymentTerm != undefined) {
      this.PendingVendorDto!.payment_term = this.paymentTerm
    }
    if (this.purchaseOrgannization != null && this.purchaseOrgannization != undefined) {
      this.PendingVendorDto!.purchase_organization = this.purchaseOrgannization
    }
    if (this.withholdingtax != null && this.withholdingtax != undefined) {
      this.PendingVendorDto!.with_holding_tax = this.withholdingtax
    }
    if (this.evaluatedScore != null && this.evaluatedScore != undefined) {
      this.PendingVendorDto!.evaluatedScore = this.evaluatedScore
    }
    if (this.riskScore != null && this.riskScore != undefined) {
      this.PendingVendorDto!.riskScore = this.riskScore
    }
    // if (this.ExemptionNumber != null && this.ExemptionNumber != undefined) {
    //   this.PendingVendorDto!.exemption_number = this.ExemptionNumber
    // }
    // if (this.Exem != null && this.Exem != undefined) {
    //   this.PendingVendorDto!.exem = this.Exem
    // }
    // if (this.ExemptFrom != null && this.ExemptFrom != undefined) {
    //   const formattedDate1 = this.datePipe.transform(this.ExemptFrom, 'yyyy-MM-dd');
    //   if (formattedDate1) {
    //     this.PendingVendorDto!.exempt_from = formattedDate1
    //   }
    // }
    // if (this.ExemptTo != null && this.ExemptTo != undefined) {
    //   const date1 = this.datePipe.transform(this.ExemptTo, 'yyyy-MM-dd');
    //   if (date1) {
    //     this.PendingVendorDto!.exempt_to = date1
    //   }
    // }
    if (this.thrid_party_business_score_doc != null && this.thrid_party_business_score_doc != undefined) {
      this.PendingVendorDto!.thrid_party_business_score_doc = `/private/files/${this.thrid_party_business_score_doc.name}`;
    }
    if (this.thrid_party_evaluated_scorecard_doc != null && this.thrid_party_evaluated_scorecard_doc != undefined) {
      this.PendingVendorDto!.thrid_party_evaluated_scorecard_doc = `/private/files/${this.thrid_party_evaluated_scorecard_doc.name}`;
    }
    if (this.withHoldingMultiData) {
      this.PendingVendorDto!.with_holding_list=this.withHoldingMultiData
    }
    this.vendorService.approve_vendors(this.PendingVendorDto).then((res) => {
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        this.pendingreview ? (setTimeout(() => { this.router.navigate(['pending-review']) }, 1500)) : setTimeout(() => { this.router.navigate(['approve-vendor-list']) }, 1500)
      }
      // this.messageService.add({ severity: 'success', summary: 'Successful', detail:res.message.message, life: 1000 });
      this.isVendorStatus = false
    }).catch((error) => {
      this.isLoading = false
      console.log(error)
      this.closeConfirmationDialog()
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message.message });
    })
  }

  onReject() {
    this.confirmationService.close();
    this.isLoading = true
    this.PendingVendorDto!.reject_reason = this.rejectReason
    this.vendorService.reject_vendor(this.PendingVendorDto).then((res) => {
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        setTimeout(() => { this.router.navigate(['pending-review']) }, 1500)
      }
      this.isVendorStatus = false
    }).catch((error) => {
      console.log(error)
      this.isLoading = false
      this.closeConfirmationDialog()
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message.message });
    })
  }
  onApproveChangeRequest(){
    this.isLoading = true
    this.pendingApprovalForDialog=false
    this.vendorService.approve_vendor_change_detail(this.businessName2).then((res)=>{
      console.log(res)
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        this.isVendorStatus = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        setTimeout(() => { this.router.navigate(['pending-change-request']) }, 1500)
      }
    }).catch((error)=>{
      console.log(error)
    })
  }
  onRejectChangeRequest(){
    this.isLoading = true
    this.pendingRejectForDialog=false
    this.vendorService.reject_vendor_change_detail(this.businessName2).then((res)=>{
      console.log(res)
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        this.isVendorStatus = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        setTimeout(() => { this.router.navigate(['pending-change-request']) }, 1500)
      }
    }).catch((error)=>{
      console.log(error)
    })
  }

  closeConfirmationDialog() {
    this.accountgroup = ''
    this.paymentTerm = ''
    this.purchaseOrgannization = ''
    this.withholdingtax = ''
    this.evaluatedScore = ''
    this.riskScore = ''
    this.thrid_party_business_score_doc = null
    this.thrid_party_evaluated_scorecard_doc = null
    this.confirmationService.close();
    this.isApproveDialog = false
    this.sidebarVisible = false
    this.Wthttype = ''
    this.Wtaxcode = ''
    this.RectyData = ''
    this.ExemptionNumber = ''
    this.Exem = ''
    this.ExemptFrom = undefined
    this.ExemptTo = undefined
    this.isWithHoldingTaxYes = false
  }
  onResetWithHolding(){
    this.Wthttype = ''
    this.Wtaxcode = ''
    this.RectyData = ''
    this.reconciliationName=''
    this.WithHoldingTaxType=''
    this.WithHoldingTaxCodeName=''
    this.ExemptionNumber = ''
    this.Exem = ''
    this.ExemptFrom = undefined
    this.ExemptTo = undefined
  }
  oncloseHolding(){
    this.Wthttype = ''
    this.Wtaxcode = ''
    this.RectyData = ''
    this.reconciliationName=''
    this.WithHoldingTaxType=''
    this.WithHoldingTaxCodeName=''
    this.ExemptionNumber = ''
    this.Exem = ''
    this.ExemptFrom = undefined
    this.ExemptTo = undefined
    this.sidebarVisible = false
    this.withholdingtax=''
    this.withHoldingMultiData =[]
  }
  closeRejectDialog() {
    this.isRejectDialog = false
    this.rejectReason = ''
    this.confirmationService.close();
  }
  closeWithHoldingDialog() {
    this.isWithHoldingTaxYes = false
  }

  OnChangeWithholding(data: any) {
    if (data === 'Yes') {
      this.isWithHoldingTaxYes = true
      this.isSelectNo = false
      this.isApproved2=false
      this.sidebarVisible = true
      this.isApproveDialog=false
    }
    if (data === 'No') {
      this.sidebarVisible = false
      this.isSelectNo = true
      this.isApproved2=true
      this.isWithHoldingTaxYes = false
      this.accountgroup = ''
      this.paymentTerm = ''
      this.purchaseOrgannization = ''
      this.reconciliationName=''
      this.WithHoldingTaxType=''
      this.WithHoldingTaxCodeName=''
      // this.withholdingtax = ''
      this.evaluatedScore = ''
      this.riskScore = ''
      this.Wthttype = ''
      this.Wtaxcode = ''
      this.RectyData = ''
      this.ExemptionNumber = ''
      this.Exem = ''
      this.ExemptFrom = undefined
      this.ExemptTo = undefined
    }
  }

  OnChangeReconciliation(data: any) {
    this.reconciliationName = data.type
    this.PendingVendorDto!.reconciliation_type = data.type
  }
  OnChangeWithholdingTaxCode(data: any) {
    this.WithHoldingTaxCodeName = data.tax_code
    this.PendingVendorDto!.with_holding_tax_code = data.tax_code
  }
  OnChangeWithholdingTaxType(data: any) {
    this.WithHoldingTaxType = data.tax_type
    this.PendingVendorDto!.with_holding_tax_type = data.tax_type
  }

  getSeverity(data: string): string {
    if (!data) {
      return 'info';
    }

    switch (data) {
      case 'PENDING_REVIEW':
        this.headerStatus = "Pending Review"
        return 'pendingreview';
      case 'Draft':
        this.headerStatus = "Draft"
        return 'draft';
      case 'PENDING_APPROVER_1':
        this.headerStatus = "Pending For Department Approval"
        return 'pendingapproval1';
      case 'PENDING_APPROVER_2':
        this.headerStatus = "Pending For Final Approval"
        return 'pendingapproval2';
      case 'APPROVED':
        this.headerStatus = "APPROVED"
        return 'approved';
      default:
        this.headerStatus = ""
        return 'info';
    }
  }


  getSeverityClass(severity: string): string {
    switch (severity) {
      case 'approved':
        return 'approved';
      case 'pendingapproval2':
        return 'pendingapproval2';
      case 'pendingapproval1':
        return 'pendingapproval1';
      case 'draft':
        return 'draft';
      case 'pendingreview':
        return 'pendingreview';
      default:
        return '';
    }
  }

  addWithholding(){
    const formattedDate1 = this.datePipe.transform(this.ExemptFrom, 'yyyy-MM-dd');
    const formattedDate2 = this.datePipe.transform(this.ExemptTo, 'yyyy-MM-dd');

    let withHoldingInterface: WithHoldingTaxDto = {
      reconciliation_type: this.RectyData.type,
      reconciliation_name:this.RectyData.description,
      with_holding_tax_type:this.Wthttype.tax_type,
      with_holding_tax_type_name:this.Wthttype.description,
      with_holding_tax_code:this.Wtaxcode.tax_code,
      with_holding_tax_code_name:this.Wtaxcode.description,
      exemption_number:this.ExemptionNumber,
      exem:this.Exem,
      exempt_from:formattedDate1 ? formattedDate1:'',
      exempt_to:formattedDate2 ? formattedDate2:''
    };
    this.withHoldingMultiData.push(withHoldingInterface)
    if (this.ExemptionNumber != null && this.ExemptionNumber != undefined) {
      this.PendingVendorDto!.exemption_number = this.ExemptionNumber
    }
    if (this.Exem != null && this.Exem != undefined) {
      this.PendingVendorDto!.exem = this.Exem
    }
    if (this.ExemptFrom != null && this.ExemptFrom != undefined) {
      const formattedDate1 = this.datePipe.transform(this.ExemptFrom, 'yyyy-MM-dd');
      if (formattedDate1) {
        this.PendingVendorDto!.exempt_from = formattedDate1
      }
    }
    if (this.ExemptTo != null && this.ExemptTo != undefined) {
      const date1 = this.datePipe.transform(this.ExemptTo, 'yyyy-MM-dd');
      if (date1) {
        this.PendingVendorDto!.exempt_to = date1
      }
    }

    if (this.withHoldingMultiData.length > 0) {
      this.isApproved=false
    }
    this.onResetWithHolding()
  }
}


